import { useParticipantsHumansControllerGetHumanProgramsQuery } from '@api/admin/adminGeneratedApi';

export const useGetHumanProgramsById = (id: string) => {
  const { isLoading, isError, data } = useParticipantsHumansControllerGetHumanProgramsQuery({ id });

  return { data, isLoading, isError };
};
